export const ExportType = {
  TYPE_EXPORT_PNG: 'export_png',
  TYPE_EXPORT_WIDGET_PNG: 'export_widget_png',
  TYPE_EXPORT_PDF: 'export_pdf',
  TYPE_EXPORT_PPT: 'export_ppt',
  TYPE_EXPORT_XLS: 'export_xls',
  TYPE_EXPORT_BUILDER_PDF: 'export_builder_pdf',
  TYPE_SCHEDULED_REPORT_PDF: 'scheduled_report_pdf',
};

export const ExportParams = {
  TYPE_PNG: 'png',
  TYPE_EXCEL: 'excel/widget',
  TYPE_CSV: 'csv/widget',
};

export const PageOrientation = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
};

const shortSide = 1224;
export const PageDimensions = {
  SHORT_SIDE: shortSide,
  LONG_SIDE: (11 / 8.5) * shortSide,
};

export const ExportPaginationDebugEvents = {
  PAGINATION_CONTINUE: 'PAGINATION_CONTINUE',
  PAGINATION_FINISH: 'PAGINATION_FINISH',
  PAGINATION_DETAILS: 'PAGINATION_DETAILS',
};

export const UsablePageDimensions = {
  MAX_HEIGHT: 1180,
  MAX_ROWS: 14,
  VERTICAL_PADDING: 5,
  START_POSITION: 14,
  PUSH_MEDIA_HEADERS_AT: 9,
  TOO_TALL_FOR_ONE_PAGE: 1110,
  MAX_COLS: 12,
  MAX_IMAGE_WIDTH_IN_DATA_GRID: 800,
};

export const ExportDataTags = {
  LOCAL_STORAGE_DEBUG_ENABLED: 'pagination_debug',
  LOCAL_STORAGE_DEBUG_VAR: 'pagination_debug_widget_id',
  MEDIA_HEADER_SELECTOR: 'data-pagination-widget-media-header',
  PAGE_HEADER_SELECTOR: 'data-pagination-page-header',
  WIDGET_HEADER_SELECTOR: 'data-pagination-widget-header',
};

export const MAX_EMBEDDED_SPARKLINES_ROWS = 20;
export const MAX_EMBEDDED_SPARKLINES = 300;

export function GetConcatSelectorForFixedWidthColumns(searchFor = 'fixedWidth') {
  const querySelector = [];
  const columns =
    searchFor === 'fixedWidth' ? ColumnSelectors.FixedWidthColumns : ColumnSelectors.ImageColumns;
  columns.forEach((className) => {
    querySelector.push(`div:has(${className})`);
  });

  return querySelector.join(', ');
}

export const ComparisonSignifier = '000000001';

export const ColumnSelectors = {
  FixedWidthColumns: [
    '.column-format-integer',
    '.column-format-percent',
    '.column-format-currency',
    '.column-format-decimal',
  ],
  ImageColumns: ['.render-html.image-preview.full'],
  ImagePreview: '.render-html.image-preview:not(.full)',
};
